import { AdminApi } from "./constants";
import { postAsync } from "./restHelper";
import {
  protectedApiRequest,
} from "./protected/protectedClientHelper";
import protectedClient from "./protected/protectedClient";
import optionalProtectedClient from "./protected/optionalProtectedClient";

const optionalApiRequest = async (apiFunction) => {
  try {
    const response = await apiFunction();
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      return null;
    }
    console.error("Something went wrong.");
    return null;
  }
};

// Export the API functions
export const getProjects = async () => {
  return protectedApiRequest(() => protectedClient.get(AdminApi.GET_PROJECTS));
};

export const getOrder = async (projectId, orderId) => {
  return protectedApiRequest(() => 
    protectedClient.get(`${AdminApi.GET_ORDER}/${orderId}`, {
      params: { projectId }
    })
  );
};

export const getTicket = async (projectId, ticketId) => {
  return protectedApiRequest(() => 
    protectedClient.get(`${AdminApi.GET_TICKET}/${ticketId}`, {
      params: { projectId }
    })
  );
};

export const searchOrderById = async (projectId, orderId) => {
  return protectedApiRequest(() => 
    protectedClient.get(`${AdminApi.GET_SEARCH_ORDER_BY_ID}/${orderId}`, {
      params: { projectId }
    })
  );
};

export const searchOrderByPhone = async (projectId, phoneNumber) => {


  return protectedApiRequest(() => 
    protectedClient.get(`${AdminApi.GET_SEARCH_ORDER_BY_PHONE}`, {
      params: { projectId, phoneNumber: phoneNumber }
    })
  );
};

export const getTicketCount = async (projectId) => {
  return optionalApiRequest(() =>
    optionalProtectedClient.get(`${AdminApi.GET_TICKET_COUNT}/${projectId}/count`)
  );
};

export const getProductDeparturesCount = async (projectId) => {
  return optionalApiRequest(() =>
    optionalProtectedClient.get(`${AdminApi.GET_PRODUCT_DEPARTURES_COUNT}/${projectId}/products/departures/count`)
  );
};


export const activateTicket = async (referenceId) => {
  return protectedApiRequest(() => 
    protectedClient.post(`${AdminApi.POST_ACTIVATE_TICKET}`, {
      referenceId: referenceId
    })
  );
};

// Identity functions
export async function identityAuthorized() {
  var phone = localStorage.getItem("phoneNumber");

  if (phone === undefined || phone === null) {
    return undefined;
  } else {
    return protectedApiRequest(() =>
      protectedClient.get(AdminApi.POST_IDENTITY_AUTHORIZED)
    );
  }
}

export async function postPasscode(phoneNumber, verificationCode) {
  let bodyObject = {
    phoneNumber: phoneNumber,
    verificationCode: verificationCode,
  };
  return postAsync(AdminApi.POST_IDENTITY_PASSCODE, bodyObject);
}

export async function postLogin(phoneNumber) {
  let bodyObject = {
    phoneNumber: phoneNumber,
  };
  return postAsync(AdminApi.POST_IDENTITY_LOGIN, bodyObject);
}
